module.exports = __webpack_public_path__ + "static/media/img173.7e8f975c.jpg";